<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="5">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Order Number"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="filterDataByPayment"
                  flat
                  solo
                  prepend-inner-icon="filter_alt"
                  hide-details
                  placeholder="All Order Types"
                  append-icon="arrow_drop_down"
                  :menu-props="{
                    offsetY: true,
                    contentClass: 'txtCap',
                  }"
                  class="txtCap"
                  :items="['delivery', 'coco']"
                ></v-select>
              </v-col>
              <!-- <v-col cols="2">
                <v-select
                  flat
                  solo
                  hide-details
                  label="Order By Brand"
                  append-icon="arrow_drop_down"
                  :items="[]"
                ></v-select>
              </v-col> -->
              <v-col cols="3" class="d-flex">
                <!-- filterDataByDate: {{ filterDataByDate }} - nowDate: -->
                <!-- {{ nowDate }} -->
                <!-- {{ pickedDateMsg }} -->
                <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="cursor: pointer">
                      <v-text-field
                        :placeholder="pickedDateMsg"
                        prepend-inner-icon="mdi-calendar-month-outline"
                        append-icon="arrow_drop_down"
                        hint="YYYY-MM-DD"
                        dense
                        solo
                        flat
                        hide-details
                        class="pry-filled-dropdown"
                        background-color="success"
                        color="white"
                        readonly
                      ></v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="filterDataByDate"
                    :menu-props="{ offsetY: true }"
                    scrollable
                    color="primary"
                    header-color="primary"
                    width="400px"
                  >
                  </v-date-picker>
                </v-menu>
                <v-icon size="10" class="cursorMe pa-2" @click="resetToAll">
                  repeat
                </v-icon>
              </v-col>
            </v-row>
          </div>
          <!-- main view -->
          <div>
            <pre>
              <!-- {{ allOrdersCOPY }} -->
            </pre>
            <v-row>
              <v-col cols="12" sm="6" md="6"></v-col>
              <v-col cols="12" sm="6" md="6">
                <v-row class="total-count-row">
                  <v-col cols="6">
                    <v-row class="count-row-1">
                      <v-col cols="6">
                        <div class="total-orders">
                          <span>Total Orders</span>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="total-orders-count">
                          <span>{{ allOrdersLength }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="6">
                        <div class="total-amount">
                          <span>Total Amount</span>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="total-amount-count">
                          <span>{{
                            totalAmount
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div class="table-menu">
                  <v-data-table
                    :headers="headers"
                    :items="filteredSearchResult"
                    item-key="id"
                    class="elevation-0 dataTableUI staffTable border-me-light"
                  >
                    <!-- For Type -->
                    <template v-slot:[`item.paymentType`]="{ item }">
                      <span class="text-capitalize">
                        {{ item.paymentType }}
                      </span>
                    </template>

                    <!-- For Time -->
                    <template v-slot:[`item.createdAt`]="{ item }">
                      {{ new Date(item.createdAt).toDateString() }} -
                      <!-- {{ new Date(item.createdAt).getHours() }} -->
                      {{ calcDayTime(item.createdAt) }}
                      :
                      {{ new Date(item.createdAt).getMinutes() }}
                      {{ calcDayTime(item.createdAt) > 12 ? "PM" : "AM" }}
                    </template>

                    <!-- For Location -->
                    <template v-slot:[`item.location`]="{ item }">
                      <span v-if="item.location">{{
                        item.location.locationName
                      }}</span>
                    </template>

                    <!-- For Brand -->
                    <template v-slot:[`item.brand`]="{ item }">
                      <span v-if="item.brand">{{ item.brand.brandName }}</span>
                    </template>

                    <!-- For Status -->
                    <template v-slot:[`item.isDelivered`]="{ item }">
                      <span v-if="item.isDelivered">Delivered</span>
                      <span v-else-if="!item.isDelivered && item.isReady">
                        Ready
                      </span>
                      <span v-else>No Status</span>
                    </template>

                    <!-- For Actions -->
                    <template v-slot:[`item.action`]="{ item }">
                      <v-icon @click="orderDetails(item)">
                        mdi-information-outline
                      </v-icon>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- final order dialog -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <div v-if="bulkUploadMenuActive" class="formLayerCard">
                  <div class="dialog-header">
                    <img
                      src="../../assets/order-logo.png"
                      class="image-dialog"
                      width="40"
                    />
                  </div>
                  <div class="dialog-content">
                    <div class="dialog-content call-center">
                      <h5>Call Center</h5>
                      <v-spacer />
                      <h4>RECEIPT #{{ selectedOrder.referenceId }}</h4>
                    </div>
                    <div>
                      <div class="dialog-content delivery-to">
                        <h4>
                          <v-icon>mdi-color-helper</v-icon> DELIVERY TO
                          <v-icon>mdi-color-helper</v-icon>
                        </h4>
                      </div>
                      <div class="dialog-content delivery-details">
                        <span
                          ><strong>{{
                            selectedOrder.customer.fullName
                          }}</strong></span
                        >
                        <br />
                        <span><strong>209-3773-87637</strong></span>
                      </div>
                      <div class="dialog-content delivery-details-sub">
                        <p>
                          {{ selectedOrder.customer.deliveryAddress }}
                        </p>
                      </div>
                      <v-divider class="divider-1" />
                      <div class="dialog-content-sub">
                        <div class="dialog-content-sub details">
                          <h4>
                            <strong>Customer:</strong>
                            {{ selectedOrder.customer.fullName }}
                          </h4>
                          <h4>
                            <strong>Staff:</strong>
                            {{ selectedOrder.userId }}
                          </h4>
                          <h4>
                            <span>9:45 am</span
                            ><span style="float: right">27-Dec-2020</span>
                          </h4>
                        </div>
                      </div>
                      <v-divider class="divider-1" />
                      <div>
                        <v-row>
                          <v-col cols="4">
                            <h4>Item</h4>
                          </v-col>
                          <v-col cols="4">
                            <h4>Qty</h4>
                          </v-col>
                          <v-col cols="4">
                            <h4>Amount</h4>
                          </v-col>
                        </v-row>
                        <v-divider class="divider-1" />
                        <v-row
                          class="table-row"
                          v-for="(orderItem, index) in orderItems"
                          :key="index"
                        >
                          <v-col cols="4" class="first-col">
                            <p>{{ orderItem.menuvariation.menu.name }}</p>
                          </v-col>
                          <v-col cols="4">
                            <h4>{{ orderItem.quantity }}</h4>
                          </v-col>
                          <v-col cols="4">
                            <h4>{{ orderItem.price }}</h4>
                          </v-col>
                        </v-row>
                        <v-divider class="divider-1" />
                        <v-row>
                          <v-col cols="4"></v-col>
                          <v-col cols="4">
                            <h4>Sub Total:</h4>
                          </v-col>
                          <v-col cols="4">
                            <h4>{{ selectedOrder.getSubTotal }}</h4>
                          </v-col>
                        </v-row>
                        <v-row class="table-row-two-sub">
                          <v-col cols="4"></v-col>
                          <v-col cols="4">
                            <h4>Total:</h4>
                          </v-col>
                          <v-col cols="4">
                            <h4>{{ selectedOrder.getSubTotal }}</h4>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <div class="dialogAction text-right">
                    <v-btn
                      @click="
                        openDialog = false;
                        bulkUploadStaffActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      @click="
                        openDialog = false;
                        bulkUploadStaffActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Print Receipt
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- view order dialog -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openFirstDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <div v-if="viewOrderIsActive" class="formLayerCard">
                  <div class="dialog-header-first">
                    <v-row class="dialog-header-first-row">
                      <v-col cols="2">
                        <img
                          src="../../assets/order-logo.png"
                          class="image-dialog"
                          width="40"
                        />
                      </v-col>
                      <v-col cols="3">
                        <h4>ORDER #{{ selectedOrder.referenceId }}</h4>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="dialog-content-first">
                    <div class="border-box">
                      <table class="tableUI staffTable">
                        <thead>
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Sub-Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="orderItem in orderItems"
                            :key="orderItem.id"
                          >
                            <td>{{ orderItem.menuvariation.menu.name }}</td>
                            <td>{{ orderItem.quantity }}</td>
                            <td>{{ orderItem.price }}</td>
                            <td>{{ orderItem.subtotal }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="border-box-2">
                      <v-row>
                        <v-col cols="6" id="border-box-firstCol">
                          <h5>Sub Total</h5>
                        </v-col>
                        <v-col cols="6" id="border-box-secondCol">
                          <h5>{{ selectedOrder.getSubTotal }}</h5>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="border-box-2">
                      <v-row>
                        <v-col cols="6" id="border-box-firstCol">
                          <h5>Total</h5>
                        </v-col>
                        <v-col cols="6" id="border-box-secondCol">
                          <h5>{{ selectedOrder.getSubTotal }}</h5>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="customer-details">
                      <v-row>
                        <v-col cols="6">
                          <div class="details">
                            <span>Customer Name:</span>
                            <br />
                            <b>{{ selectedOrder.customer.fullName }}</b>
                          </div>
                          <div class="details">
                            <span>Phone Number:</span>
                            <br />
                            <b>{{ selectedOrder.customer.phone }} </b>
                          </div>
                          <div class="details">
                            <span>Delivery Area:</span>
                            <br />
                            <b>{{ selectedOrder.customer.deliveryArea }} </b>
                          </div>
                          <div class="details">
                            <span>Delivery Address:</span>
                            <br />
                            <b>
                              <span>
                                {{
                                  selectedOrder.customer.buildingNumber +
                                  ", " +
                                  selectedOrder.customer.streetName +
                                  ","
                                }}
                              </span>
                              <span>
                                {{
                                  selectedOrder.customer.nearestLandmark + ","
                                }}
                              </span>
                              <span>
                                {{ selectedOrder.customer.deliveryArea + "." }}
                              </span>
                            </b>
                          </div>
                        </v-col>
                        <v-col cols="1">
                          <v-divider vertical />
                        </v-col>
                        <v-col cols="5">
                          <div class="details">
                            <span>Order Number:</span>
                            <br />
                            <b>{{ selectedOrder.referenceId }} </b>
                          </div>
                          <div class="details">
                            <span>Location/Branch:</span>
                            <br />
                            <b>{{ selectedOrder.customer.deliveryArea }} </b>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="button-div">
                      <v-btn class="grey--text mr-3" @click="showFinalReceipt"
                        >Print Order</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="default--text mr-3"
                        @click="modifyCustomer"
                      >
                        Modify Customer
                      </v-btn>
                    </div>
                  </div>
                  <div class="dialogAction text-right">
                    <v-btn
                      @click="
                        openFirstDialog = false;
                        viewOrderIsActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Close
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: "Total Orders",
      dataReady: false,
      allOrdersCOPY: [],
      startDate: "",
      nowDate: new Date().toISOString().slice(0, 10),
      pickedDateMsg: "",
      filterDataByDate: "",
      filterDataByPayment: "",
      headers: [
        {
          text: "Order ID",
          align: "start",
          sortable: true,
          value: "id",
          width: 300,
        },
        {
          text: "Time",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Type",
          align: "start",
          sortable: false,
          value: "paymentType",
        },
        {
          text: "Customer",
          value: "customer.fullName",
          sortable: false,
        },
        {
          text: "Location",
          value: "location",
          sortable: false,
        },
        {
          text: "Amount",
          value: "price",
          sortable: false,
        },
        {
          text: "Payments",
          value: "paymentMethod",
          sortable: false,
        },
        {
          text: "Status",
          value: "isDelivered",
          sortable: false,
        },
        {
          text: "",
          sortable: false,
          value: "action",
        },
      ],
      selectedOrder: [],
      orderItems: [],
      openDialog: false,
      bulkUploadMenuActive: false,
      viewOrderIsActive: false,
      openFirstDialog: false,
      searchQuery: "",
    };
  },
  created() {
    this.$store.dispatch("getAllOrders");
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.allOrdersCOPY;

      // Filter for Date Picker selection
      const filterDataByDate = this.filterDataByDate;
      if (filterDataByDate) {
        grabArr = grabArr.filter(
          (order) =>
            new Date(order.createdAt).toISOString().slice(0, 10) ==
            filterDataByDate
        );
      }

      // Filtere for paymentType
      const filterDataByPayment = this.filterDataByPayment;
      if (filterDataByPayment) {
        grabArr = grabArr.filter(
          (order) => order.paymentType == filterDataByPayment
        );
      }

      return grabArr.filter((item) => {
        if (
          item.id.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1 // search by email
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "allOrders", "userType"]),
    allOrdersLength() {
      return this.filteredSearchResult.length;
    },
    totalAmount() {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      let amount = this.filteredSearchResult.map((order) => order.price);
      let calcTotalReceived = amount.reduce(reducer, 0);
      return calcTotalReceived;
    },
  },
  methods: {
    modifyCustomer() {
      window.open(
        "/customers?customer=" + this.selectedOrder.customerId,
        "_blank"
      );
    },
    resetToAll() {
      this.filterDataByDate = "";
      this.filterDataByPayment = "";

      this.filteredSearchResult;
      this.pickedDateMsg = "All Orders";
    },
    calcDayTime(date) {
      let hr = new Date(date).getHours();

      if (hr > 12) {
        return hr - 12;
      } else {
        return hr;
      }
    },
    orderDetails(data) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      // duplicate locally
      this.selectedOrder = data;

      // set orders
      this.orderItems = data.orderitems;

      // map and reduce (sum all figures)
      this.selectedOrder.getSubTotal = this.orderItems
        .map((item) => item.subtotal)
        .reduce(reducer, 0);

      this.viewOrderIsActive = true;
      this.openFirstDialog = true;
    },
    addNewMenu() {
      this.$router.push("/menus/item-details");
    },
    showFinalReceipt() {
      this.openFirstDialog = false;
      this.viewOrderIsActive = false;
      this.openDialog = true;
      this.bulkUploadMenuActive = true;
    },
  },
  watch: {
    allOrders(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
        this.allOrdersCOPY = this.allOrders;

        // set initial date picked
        // this.filterDataByDate = this.nowDate; // set initial to today's date
        this.pickedDateMsg = "All Orders";

        // set init date
        // this.filterDataByDate = this.nowDate;
      }
    },
    filterDataByDate(val) {
      if (val && val != this.nowDate) {
        this.pickedDateMsg =
          "Day: " + new Date(this.filterDataByDate).toDateString();
      } else if (val == this.nowDate) {
        this.pickedDateMsg =
          "Today: " + new Date(this.filterDataByDate).toDateString();
      }
    },
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
  mounted() {},
};
</script>

<style scoped>
.orderMenu td {
  text-transform: capitalize;
}

.table-menu {
  width: 92%;
}

.dialog-header-first-row {
  margin-left: 3%;
  margin-top: -2%;
}

.mr-3 {
  text-transform: capitalize;
  font-size: 13px;
}

.table-row {
  margin-top: -1%;
}

.table-row-two {
  margin-top: -5%;
}

.table-row-two-sub {
  margin-top: -3%;
}

.first-col {
  text-align: right;
}

>>> .pry-filled-dropdown input {
  cursor: pointer;
}

>>> .pry-filled-dropdown i {
  color: white;
  cursor: pointer;
}

>>> .pry-filled-dropdown input::placeholder {
  color: white;
  cursor: pointer;
}
</style>
